import types from "../../../constants/action-types"

export const setGeoLocation = (payload) => ({
  type: types.SET_GEOLOCATION,
  payload,
})

export const setOpenPopupId = (payload) => ({
  type: types.OPEN_POPUP_ID,
  payload,
})

export const clearGeoLocation = () => {
  return {
    type: types.CLEAR_GEOLOCATION,
  }
}
